/* KASTENKISTE Theme · Basis-Interaktionen */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-kk-burger]');
  if(b){ var n=document.querySelector('[data-kk-nav]'); if(n){ n.classList.toggle('offen');
    b.setAttribute('aria-expanded', n.classList.contains('offen')?'true':'false'); } }
  var y=e.target.closest('[data-kk-youtube]');
  if(y){ var id=y.getAttribute('data-kk-youtube');
    var f=document.createElement('iframe');
    f.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';
    f.title='Video'; f.allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen=true; f.loading='lazy';
    f.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:0;';
    y.parentNode.appendChild(f); y.remove(); }
});
/* FAQ-Aufklapper mit <details> braucht kein JS – hier nur Analytics-freie Basis */

/* Vorher/Nachher-Slider */
(function(){
  function init(root){
    var oben=root.querySelector('.kk-slider__oben'), griff=root.querySelector('.kk-slider__griff'), rahmen=root.querySelector('.kk-slider__rahmen');
    if(!oben||!griff||!rahmen||rahmen.dataset.kkAktiv)return;
    rahmen.dataset.kkAktiv='1';
    var img=oben.querySelector('img');
    function mass(){ if(img){ img.style.width=rahmen.clientWidth+'px'; } }
    function setze(p){ p=Math.max(2,Math.min(98,p)); oben.style.width=p+'%'; griff.style.left=p+'%'; griff.setAttribute('aria-valuenow',Math.round(p)); }
    function ausEvent(e){ var r=rahmen.getBoundingClientRect(); var x=(e.touches?e.touches[0].clientX:e.clientX)-r.left; setze(x/r.width*100); }
    var zieht=false;
    rahmen.addEventListener('pointerdown',function(e){ zieht=true; rahmen.setPointerCapture&&rahmen.setPointerCapture(e.pointerId); ausEvent(e); });
    rahmen.addEventListener('pointermove',function(e){ if(zieht)ausEvent(e); });
    ['pointerup','pointercancel','pointerleave'].forEach(function(t){ rahmen.addEventListener(t,function(){ zieht=false; }); });
    griff.addEventListener('keydown',function(e){ var p=parseFloat(oben.style.width)||50;
      if(e.key==='ArrowLeft'){ setze(p-4); e.preventDefault(); } if(e.key==='ArrowRight'){ setze(p+4); e.preventDefault(); } });
    window.addEventListener('resize',mass); mass(); setze(50);
  }
  function alle(){ document.querySelectorAll('[data-kk-vergleich]').forEach(init); }
  document.addEventListener('DOMContentLoaded',alle);
  document.addEventListener('kk:seite-gewechselt',alle);
  alle();
})();

/* Drei-Zustands-Slider: Mitte Original, links Heckauszug, rechts Kastenkiste */
(function(){
  function init(root){
    var rahmen=root.querySelector('.kk-slider__rahmen'); if(!rahmen||rahmen.dataset.kkAktiv)return;
    rahmen.dataset.kkAktiv='1';
    var griff=root.querySelector('.kk-slider__griff'),
        L=root.querySelector('[data-ebene="links"]'), R=root.querySelector('[data-ebene="rechts"]'),
        tL=root.querySelector('.kk-slider__tag--l'), tM=root.querySelector('.kk-slider__tag--m'), tR=root.querySelector('.kk-slider__tag--r');
    function setze(p){
      p=Math.max(0,Math.min(100,p));
      griff.style.left=p+'%'; griff.setAttribute('aria-valuenow',Math.round(p));
      var l=Math.max(0,(50-p)/50), r=Math.max(0,(p-50)/50);
      if(L)L.style.opacity=l; if(R)R.style.opacity=r;
      [tL,tM,tR].forEach(function(t){t&&t.classList.remove('aktiv');});
      var akt = l>.5?tL : r>.5?tR : tM; akt&&akt.classList.add('aktiv');
    }
    function ausEvent(e){ var b=rahmen.getBoundingClientRect();
      var x=(e.touches?e.touches[0].clientX:e.clientX)-b.left; setze(x/b.width*100); }
    var zieht=false;
    rahmen.addEventListener('pointerdown',function(e){ zieht=true; rahmen.setPointerCapture&&rahmen.setPointerCapture(e.pointerId); ausEvent(e); });
    rahmen.addEventListener('pointermove',function(e){ if(zieht)ausEvent(e); });
    ['pointerup','pointercancel','pointerleave'].forEach(function(t){ rahmen.addEventListener(t,function(){ zieht=false; }); });
    griff.addEventListener('keydown',function(e){ var p=parseFloat(griff.style.left)||50;
      if(e.key==='ArrowLeft'){ setze(p-4); e.preventDefault(); }
      if(e.key==='ArrowRight'){ setze(p+4); e.preventDefault(); }
      if(e.key==='Home'){ setze(50); e.preventDefault(); } });
    setze(50);
  }
  function alle(){ document.querySelectorAll('[data-kk-drei]').forEach(init); }
  document.addEventListener('DOMContentLoaded',alle);
  document.addEventListener('kk:seite-gewechselt',alle);
  alle();
})();
